import { DateTime } from 'luxon';
export var dateGuard = function dateGuard(date) {
  if (date && DateTime.fromISO(date).isValid) {
    return DateTime.fromISO(date);
  } else {
    return undefined;
  }
};
//# sourceMappingURL=utils.js.map